export enum ASSET_TYPES {
  TENANT = "TENANT",
  CUSTOMER = "CUSTOMER",
  LOCATION = "LOCATION",
  BUILDING = "BUILDING",
  DOOR = "GATE_SYSTEM",
}

export type AssetType = `${ASSET_TYPES}`;

export type ReportAssetType = ASSET_TYPES.DOOR | ASSET_TYPES.TENANT;
